import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { ICardTitleFormatter } from '../../../schema/interfaces/card-title-formatter';

export class DefaultTitleFormatter implements ICardTitleFormatter {
  format(callcard: CallCard): string {
    const eventText: string = callcard.event ? callcard.event.EventText : '';
    return `${callcard.rLong[0]} - ${eventText}`;
  }
}
